import { system } from 'styled-system';

const config = {
  fill: {
    property: 'fill',
    scale: 'colors'
  },
  backgroundAttachment: {
    property: 'backgroundAttachment'
  },
  animation: true,
  appearance: true,
  bgImage: {
    property: 'backgroundImage'
  },
  bgSize: {
    property: 'backgroundSize'
  },
  bgPos: {
    property: 'backgroundPosition'
  },
  bgRepeat: {
    property: 'backgroundRepeat'
  },
  pos: {
    property: 'position'
  },
  boxSizing: true,
  cursor: true,
  float: true,
  listStyleType: true,
  listStylePosition: true,
  listStyleImage: true,
  objectFit: true,
  objectPosition: true,
  outline: true,
  overflowWrap: true,
  overflowX: true,
  overflowY: true,
  placeContent: true,
  placeItems: true,
  placeSelf: true,
  pointerEvents: true,
  resize: true,
  scrollBehavior: true,
  stroke: {
    property: 'stroke',
    scale: 'colors'
  },
  textAlign: true,
  textDecoration: true,
  textOverflow: true,
  textTransform: true,
  transform: true,
  transformOrigin: true,
  transitionProperty: true,
  transition: {
    property: 'transition',
    scale: 'transitions'
  },
  userSelect: true,
  visibility: true,
  whiteSpace: true,
  wordBreak: true,
  gap: {
    property: 'gap',
    scale: 'space'
  },
  filter: true,
  scrollMargin: true,
  scrollMarginTop: true,
  scrollMarginBottom: true,
  scrollMarginLeft: true,
  scrollMarginRight: true
};
// @ts-ignore
const extraConfig = system(config);

export { config, extraConfig };
